"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.deleteUserActivityErrorSelector = exports.deleteUserActivityIsLoadingSelector = exports.deletedUserActivityIdSelector = exports.deleteUserActivitySelector = exports.editUserActivityErrorSelector = exports.editUserActivityIsLoadingSelector = exports.editedUserActivityIdSelector = exports.editUserActivitySelector = exports.createUserActivityErrorSelector = exports.createUserActivityIsLoadingSelector = exports.createdUserActivitySelector = exports.createUserActivitySelector = exports.replayUserActivityErrorSelector = exports.replayUserActivityIsLoadingSelector = exports.replayedUserActivityIdSelector = exports.replayUserActivitySelector = exports.loadUserActivitiesErrorSelector = exports.loadUserActivitiesIsLoadingSelector = exports.loadUserActivitiesMetaDataSelector = exports.loadUserActivitiesDataSelector = exports.loadUserActivitiesSelector = exports.userActivitiesStateSelector = void 0;

var _reselect = require("reselect");

var userStateSelector = function userStateSelector(state) {
  return state.user;
};

var userActivitiesStateSelector = (0, _reselect.createSelector)(userStateSelector, function (user) {
  return user.activities;
});
exports.userActivitiesStateSelector = userActivitiesStateSelector;
var loadUserActivitiesSelector = (0, _reselect.createSelector)(userActivitiesStateSelector, function (activities) {
  return activities.loadUserActivities;
});
exports.loadUserActivitiesSelector = loadUserActivitiesSelector;
var loadUserActivitiesDataSelector = (0, _reselect.createSelector)(loadUserActivitiesSelector, function (loadUserActivities) {
  return loadUserActivities.data;
});
exports.loadUserActivitiesDataSelector = loadUserActivitiesDataSelector;
var loadUserActivitiesMetaDataSelector = (0, _reselect.createSelector)(loadUserActivitiesSelector, function (loadUserActivities) {
  return loadUserActivities.metadata;
});
exports.loadUserActivitiesMetaDataSelector = loadUserActivitiesMetaDataSelector;
var loadUserActivitiesIsLoadingSelector = (0, _reselect.createSelector)(loadUserActivitiesSelector, function (loadUserActivities) {
  return loadUserActivities.isLoading;
});
exports.loadUserActivitiesIsLoadingSelector = loadUserActivitiesIsLoadingSelector;
var loadUserActivitiesErrorSelector = (0, _reselect.createSelector)(loadUserActivitiesSelector, function (loadUserActivities) {
  return loadUserActivities.error;
});
exports.loadUserActivitiesErrorSelector = loadUserActivitiesErrorSelector;
var replayUserActivitySelector = (0, _reselect.createSelector)(userActivitiesStateSelector, function (activities) {
  return activities.replayUserActivity;
});
exports.replayUserActivitySelector = replayUserActivitySelector;
var replayedUserActivityIdSelector = (0, _reselect.createSelector)(replayUserActivitySelector, function (replayUserActivity) {
  return replayUserActivity.replayedActivityId;
});
exports.replayedUserActivityIdSelector = replayedUserActivityIdSelector;
var replayUserActivityIsLoadingSelector = (0, _reselect.createSelector)(replayUserActivitySelector, function (replayUserActivity) {
  return replayUserActivity.isLoading;
});
exports.replayUserActivityIsLoadingSelector = replayUserActivityIsLoadingSelector;
var replayUserActivityErrorSelector = (0, _reselect.createSelector)(replayUserActivitySelector, function (replayUserActivity) {
  return replayUserActivity.error;
});
exports.replayUserActivityErrorSelector = replayUserActivityErrorSelector;
var createUserActivitySelector = (0, _reselect.createSelector)(userActivitiesStateSelector, function (activities) {
  return activities.createUserActivity;
});
exports.createUserActivitySelector = createUserActivitySelector;
var createdUserActivitySelector = (0, _reselect.createSelector)(createUserActivitySelector, function (createUserActivity) {
  return createUserActivity.createdActivity;
});
exports.createdUserActivitySelector = createdUserActivitySelector;
var createUserActivityIsLoadingSelector = (0, _reselect.createSelector)(createUserActivitySelector, function (createUserActivity) {
  return createUserActivity.isLoading;
});
exports.createUserActivityIsLoadingSelector = createUserActivityIsLoadingSelector;
var createUserActivityErrorSelector = (0, _reselect.createSelector)(createUserActivitySelector, function (createUserActivity) {
  return createUserActivity.error;
});
exports.createUserActivityErrorSelector = createUserActivityErrorSelector;
var editUserActivitySelector = (0, _reselect.createSelector)(userActivitiesStateSelector, function (activities) {
  return activities.editUserActivity;
});
exports.editUserActivitySelector = editUserActivitySelector;
var editedUserActivityIdSelector = (0, _reselect.createSelector)(editUserActivitySelector, function (editUserActivity) {
  return editUserActivity.editedActivityId;
});
exports.editedUserActivityIdSelector = editedUserActivityIdSelector;
var editUserActivityIsLoadingSelector = (0, _reselect.createSelector)(editUserActivitySelector, function (editUserActivity) {
  return editUserActivity.isLoading;
});
exports.editUserActivityIsLoadingSelector = editUserActivityIsLoadingSelector;
var editUserActivityErrorSelector = (0, _reselect.createSelector)(editUserActivitySelector, function (editUserActivity) {
  return editUserActivity.error;
});
exports.editUserActivityErrorSelector = editUserActivityErrorSelector;
var deleteUserActivitySelector = (0, _reselect.createSelector)(userActivitiesStateSelector, function (activities) {
  return activities.deleteUserActivity;
});
exports.deleteUserActivitySelector = deleteUserActivitySelector;
var deletedUserActivityIdSelector = (0, _reselect.createSelector)(deleteUserActivitySelector, function (deleteUserActivity) {
  return deleteUserActivity.deletedActivityId;
});
exports.deletedUserActivityIdSelector = deletedUserActivityIdSelector;
var deleteUserActivityIsLoadingSelector = (0, _reselect.createSelector)(deleteUserActivitySelector, function (deleteUserActivity) {
  return deleteUserActivity.isLoading;
});
exports.deleteUserActivityIsLoadingSelector = deleteUserActivityIsLoadingSelector;
var deleteUserActivityErrorSelector = (0, _reselect.createSelector)(deleteUserActivitySelector, function (deleteUserActivity) {
  return deleteUserActivity.error;
});
exports.deleteUserActivityErrorSelector = deleteUserActivityErrorSelector;
var _default = {
  loadUserActivitiesDataSelector: loadUserActivitiesDataSelector,
  loadUserActivitiesMetaDataSelector: loadUserActivitiesMetaDataSelector,
  loadUserActivitiesIsLoadingSelector: loadUserActivitiesIsLoadingSelector,
  loadUserActivitiesErrorSelector: loadUserActivitiesErrorSelector,
  replayedUserActivityIdSelector: replayedUserActivityIdSelector,
  replayUserActivityIsLoadingSelector: replayUserActivityIsLoadingSelector,
  replayUserActivityErrorSelector: replayUserActivityErrorSelector,
  createdUserActivitySelector: createdUserActivitySelector,
  createUserActivityIsLoadingSelector: createUserActivityIsLoadingSelector,
  createUserActivityErrorSelector: createUserActivityErrorSelector,
  editedUserActivityIdSelector: editedUserActivityIdSelector,
  editUserActivityIsLoadingSelector: editUserActivityIsLoadingSelector,
  editUserActivityErrorSelector: editUserActivityErrorSelector,
  deletedUserActivityIdSelector: deletedUserActivityIdSelector,
  deleteUserActivityIsLoadingSelector: deleteUserActivityIsLoadingSelector,
  deleteUserActivityErrorSelector: deleteUserActivityErrorSelector
};
exports["default"] = _default;
//# sourceMappingURL=selectors.js.map